export const ROOT = '/system-updates';
export const MODULE = 'SystemUpdates';
